import { Popover, PopoverPanel } from '@headlessui/react'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/Button'
import { updateUser } from '@/services/user.service'

/**
 * Renders a popover for configuring a phone number for MFA.
 */
const MfaPopover = ({ children, setCurrentUser, setShow, show, user }) => {
  const navigate = useNavigate()

  const panelRef = useRef()

  /**
   * Set up the event listener for clicking outside of the popover panel.
   */
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  /**
   * Manually close the popover panel if the user clicks outside of the button or panel.
   * @param {object} event
   */
  const handleClickOutside = (event) => {
    if (!panelRef.current?.contains(event.target)) {
      event.stopPropagation()
      setShow(false)
    }
  }

  /**
   * Handles submitting the phone number verification form.
   * @param {object} data
   */
  const onSubmit = async () =>
    updateUser(
      { id: user.id, hasViewedMfaNotification: true },
      () => {},
      () => {},
      () => {},
      setCurrentUser,
    )

  return (
    <Popover className="relative">
      {children}

      {show && (
        <PopoverPanel
          ref={panelRef}
          static
          transition
          anchor="bottom"
          className="bg-background flex w-96 flex-col rounded-lg p-4 shadow-lg"
        >
          <span className="text-sm">
            To configure Multi-Factor Authentication through text message, visit your profile page
            to add a phone number and change your Multi-Factor Authentication method.
          </span>

          <div className="flex flex-row justify-end gap-4">
            <Button
              background="bg-white"
              onClick={() => {
                onSubmit()
                setShow(false)
              }}
              outlined
              label="Dismiss"
              size="xs"
              className="w-auto"
            />
            <Button
              onClick={() => {
                onSubmit()
                setShow(false)
                navigate('/profile')
              }}
              label="Go to Profile"
              size="xs"
              className="w-auto"
            />
          </div>
        </PopoverPanel>
      )}
    </Popover>
  )
}

MfaPopover.propTypes = {
  children: PropTypes.node.isRequired,
  setCurrentUser: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
}

export default MfaPopover
